import { Component } from '@angular/core';
import { AppComponent } from '../app.component';
import { AppMainComponent } from './app.main.component';

@Component({
  selector: 'app-menubutton',
  template: `
    <a class="menu-button" href="#" (click)="appMain.onMenuButtonClick($event)">
      <i class="pi cm-bars"></i>
    </a>
  `,
})
export class AppMenuButtonComponent {

  constructor(
    public appMain: AppMainComponent,
    public app: AppComponent,
  ) {}
}
